<template>
    <header
        v-if="!zoom"
        class="header"
        :style="{ height: zoom ? '0px' : 'auto' }"
    >
        <div class="header-container">
            <div class="left-section">
                <div class="logo-container">
                    <img src="@/assets/img/header/logo.svg" class="logo-left" />
                </div>
                <div class="text-left">
                    <span>CƠ SỞ DỮ LIỆU NGÀNH</span>
                </div>
            </div>

            <div class="right-section">
                <div class="controls-container">
                    <!-- Database mode controls -->
                    <template v-if="headerMode === 'database'">
                        <div
                            v-if="shouldShowGradeLevel()"
                            class="grade-level-control"
                        >
                            <span class="text-grade-level">Cấp học:</span>
                            <ESelect
                                style="width: 200px"
                                :clearable="true"
                                :disabled="false"
                                :data="filteredGradeLevels"
                                :placeholder="'Chọn'"
                                :filterable="true"
                                :multiple="true"
                                :collapse-tags="true"
                                :fields="['label', 'value']"
                                v-model="tempSelectedGradeLevel"
                                class="select-grade-level"
                                @change="onChangeGradeLevel"
                            />
                        </div>

                        <div class="educational-control">
                            <el-tooltip
                                content="Cấu hình năm học"
                                placement="bottom"
                                effect="dark"
                            >
                                <div
                                    class="modal-educational educational"
                                    @click="openModalEducationalSession"
                                >
                                    <b>
                                        {{
                                            convertNameSemester(
                                                selectedSemesterFromStore
                                            )
                                        }}
                                        {{ selectedYearFromStore }} -
                                        {{ selectedYearFromStore + 1 }}
                                    </b>
                                </div>
                            </el-tooltip>
                        </div>

                        <div class="instruct-control">
                            <b class="instruct" @click="viewInstruction"
                                >Hướng dẫn</b
                            >
                        </div>
                    </template>

                    <!-- Mode Switcher Button -->
                    <div class="mode-toggle-container">
                        <div
                            ref="modeToggleButton"
                            class="mode-toggle-button"
                            @click="toggleModeDropdown"
                        >
                            <i class="el-icon-menu"></i>
                        </div>
                        <div
                            v-if="showModeDropdown"
                            ref="modeDropdown"
                            class="mode-dropdown"
                        >
                            <div
                                class="mode-option"
                                :class="{ active: headerMode === 'database' }"
                                @click="switchToDatabase"
                            >
                                <div class="mode-icon database-icon">
                                    <i class="el-icon-s-data"></i>
                                </div>
                                <span>CSDL ngành</span>
                            </div>
                            <div
                                class="mode-option"
                                :class="{ active: headerMode === 'profile' }"
                                @click="switchToProfile"
                            >
                                <div class="mode-icon profile-icon">
                                    <i class="el-icon-folder-opened"></i>
                                </div>
                                <span>Tra cứu hồ sơ</span>
                            </div>
                        </div>
                    </div>

                    <!-- Profile mode controls -->
                    <template v-if="headerMode === 'profile'">
                        <div class="notification-control">
                            <el-badge class="notification-badge">
                                <div class="notification-icon">
                                    <i class="el-icon-bell"></i>
                                </div>
                            </el-badge>
                        </div>

                        <div class="avatar-control">
                            <div class="user-avatar">
                                <i class="el-icon-user"></i>
                            </div>
                        </div>
                    </template>

                    <!-- Desktop account dropdown (shown in both modes) -->
                    <div class="desktop-account">
                        <b-dropdown
                            right
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                        >
                            <template #button-content>
                                <em class="user-name">
                                    {{ auth_user?.username }}
                                    <i
                                        class="el-icon-arrow-down el-icon--right"
                                    ></i>
                                </em>
                            </template>
                            <b-dropdown-item
                                class="user-name"
                                @click="navigateAccountUser"
                            >
                                Hồ sơ tài khoản
                            </b-dropdown-item>
                            <b-dropdown-item
                                class="user-name"
                                @click="navigateLoginHistory"
                            >
                                Lịch sử đăng nhập
                            </b-dropdown-item>
                            <b-dropdown-item
                                class="user-name"
                                @click="openModalChangePassword"
                            >
                                Đổi mật khẩu
                            </b-dropdown-item>
                            <b-dropdown-item
                                class="user-name"
                                @click="handleLogOut"
                            >
                                Đăng xuất
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <CustomModal
            :is-modal-visible="educationalSessionVisible"
            :modal-title="'Cấu hình năm học'"
            :close-function="closeModalEducationalSession"
            :size="'md'"
        >
            <template v-slot:content>
                <div class="row align-items-center justify-content-center">
                    <div class="semester col-md-4">Học kỳ</div>
                    <div class="col-md-8">
                        <el-select
                            style="width: 100%"
                            v-model="tempSelectedSemester"
                            placeholder="Chọn"
                            size="small"
                            popper-class="semester-select-dropdown"
                        >
                            <el-option
                                v-for="item in list_Semester"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="row align-items-center justify-content-center mt-3">
                    <div class="col-md-4 year">Năm học</div>
                    <div class="col-md-8">
                        <el-select
                            v-model="tempSelectedYear"
                            placeholder="Chọn"
                            size="small"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in list_Year"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </template>

            <template v-slot:btn-handle>
                <CustomButton
                    label="Lưu"
                    @click="handleSaveEducationalSession"
                    style="margin-left: 30px !important"
                />
            </template>
        </CustomModal>
        <ModalChangePassword
            :changePasswordVisible="changePasswordVisible"
            :closeModalChangePassword="closeModalChangePassword"
            @handleLogOut="handleLogOut"
        />
    </header>
</template>

<script>
import { getFromSessionStorage, saveToSessionStorage } from '@/utils/session'
import ESelect from '@/components/ESelect.vue'
import { list_GradeLevel, list_Semester, list_Year } from '@/mock_data/header'
import CustomModal from '@/components/CustomModal.vue'
import CustomButton from '@/components/CustomButton.vue'
import { getLabelsByArray } from '@/utils/index'
import { mapMutations } from 'vuex'
import { path } from '@/router/path'
import ModalChangePassword from '@/views/tai-khoan/doi-mat-khau/index.vue'

export default {
    name: 'HeaderComponent',
    components: { CustomModal, CustomButton, ESelect, ModalChangePassword },

    data() {
        return {
            list_grade_level_default: list_GradeLevel,
            tempSelectedGradeLevel: this.$store.state.gradeLevel.gradeLevel,

            educationalSessionVisible: false,
            list_Year,
            tempSelectedYear: this.$store.state.selectedYear.selectedYear,

            list_Semester,
            tempSelectedSemester: this.$store.state.semester.semester,

            activeIndex: '1',

            changePasswordVisible: false,

            // Mode state: 'database' or 'profile'
            headerMode: 'database',
            showModeDropdown: false,

            // Instruction file path
            instructionFilePath: '/templateImport/15062022_HDSD_Edc_SGD_v3.0.pdf'
        }
    },
    methods: {
        ...mapMutations('selectedYear', ['setSelectedYear']),
        ...mapMutations('gradeLevel', ['setGradeLevel']),
        ...mapMutations('semester', ['setSemester']),
        getLabelsByArray,
        convertNameSemester(e) {
            return e === 1
                ? 'Học kỳ I'
                : e === 2
                ? 'Học kỳ II'
                : e === 3
                ? 'Cả năm'
                : null
        },
        shouldShowGradeLevel() {
            const currentPath = this.$route.path

            return (
                currentPath !== path.lock_up.school.add_school &&
                !currentPath.startsWith(path.lock_up.school.update_school) &&
                !currentPath.startsWith(path.lock_up.class.update_class) &&
                !currentPath.startsWith(path.lock_up.student.update_student) &&
                currentPath !== path.report.emis.last &&
                currentPath !== path.report.emis.begin &&
                currentPath !== path.report.eqms &&
                currentPath !== path.report.department &&
                currentPath !== path.lock_up.attendance
            )
        },
        openModalEducationalSession() {
            this.educationalSessionVisible = true
        },
        closeModalEducationalSession() {
            this.educationalSessionVisible = false
        },

        handleSaveEducationalSession() {
            this.setSelectedYear(this.tempSelectedYear)
            this.setSemester(this.tempSelectedSemester)
            this.closeModalEducationalSession()
        },
        onChangeGradeLevel() {
            this.setGradeLevel(this.tempSelectedGradeLevel)
        },
        navigateAccountUser() {
            this.$router.push({
                path: `${path.account.user.view}`
            })
        },

        navigateLoginHistory() {
            this.$router.push({
                path: `${path.account.loginHistory}`
            })
        },
        openModalChangePassword() {
            this.changePasswordVisible = true
        },
        closeModalChangePassword() {
            this.changePasswordVisible = false
        },
        handleLogOut() {
            this.$router.push('/login')
            sessionStorage.clear()
        },
        toggleModeDropdown() {
            this.showModeDropdown = !this.showModeDropdown
        },
        closeModeDropdown() {
            this.showModeDropdown = false
        },
        switchToDatabase() {
            if (this.headerMode === 'database') {
                // Already in database mode, just close dropdown
                this.closeModeDropdown()
                return
            }
            this.headerMode = 'database'
            this.closeModeDropdown()
            // Navigate to dashboard
            this.$router.push(path.dashboard)
        },
        switchToProfile() {
            if (this.headerMode === 'profile') {
                // Already in profile mode, reload to avoid errors
                this.closeModeDropdown()
                window.location.reload()
                return
            }
            this.headerMode = 'profile'
            this.closeModeDropdown()
            // Navigate to profile base
            this.$router.push(path.profile.base)
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.modeDropdown
            const button = this.$refs.modeToggleButton
            if (
                dropdown &&
                button &&
                !dropdown.contains(event.target) &&
                !button.contains(event.target)
            ) {
                this.closeModeDropdown()
            }
        },
        updateHeaderMode() {
            const currentPath = this.$route.path
            // Check if we're in profile section
            if (currentPath.startsWith('/profile')) {
                this.headerMode = 'profile'
            } else {
                this.headerMode = 'database'
            }
        },
        viewInstruction() {
            // Open file in new tab for viewing - same as old project
            window.open(
                this.instructionFilePath,
                '_blank',
                'location=yes,scrollbars=yes,status=yes'
            )
        }
    },

    created() {
        // Initialize gradeLevel in store if it's null
        if (this.$store.state.gradeLevel.gradeLevel === null) {
            this.setGradeLevel([])
        }
        // Check initial route to set header mode
        this.updateHeaderMode()
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
    },

    watch: {
        $route() {
            this.updateHeaderMode()
        }
    },

    computed: {
        zoom() {
            return this.$store.state.zoom.zoom
        },
        selectedYearFromStore: {
            get() {
                return this.$store.state.selectedYear.selectedYear
            },
            set(value) {
                // Không thực hiện bất kỳ điều gì tại đây
            }
        },
        selectedSemesterFromStore: {
            get() {
                return this.$store.state.semester.semester
            },
            set(value) {
                // Không thực hiện bất kỳ điều gì tại đây
            }
        },

        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        filteredGradeLevels() {
            // Ensure we always use an array for filtering
            const userGradeLevels = this.auth_user?.capHocList || []
            let list_grade_level

            // If user has specific grade levels assigned, filter by those
            if (userGradeLevels.length > 0) {
                list_grade_level = this.list_grade_level_default.filter((item) =>
                    userGradeLevels.includes(parseInt(item.value))
                )
            } else {
                // If no specific grade levels, show all default grade levels
                list_grade_level = this.list_grade_level_default
            }

            saveToSessionStorage('list_grade_level', list_grade_level)
            return list_grade_level
        }
    }
}
</script>

<style scoped>
.header {
    background: var(--blue-200);
    color: var(--white-common);
    width: 100%;
    padding: 10px 20px;
}

.header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 15px;
}

.left-section {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 15px;
}

.logo-left {
    object-fit: cover;
    height: 40px;
    width: 40px;
}

.text-left {
    text-transform: uppercase;
    font-weight: 700;
    margin-left: 15px;
    line-height: 26px;
    font-size: 20px;
    white-space: nowrap;
}

.right-section {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    position: relative;
}

.controls-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
}

.grade-level-control {
    display: flex;
    align-items: center;
    gap: 8px;
}

.text-grade-level {
    font-weight: 500;
    white-space: nowrap;
    font-size: 15px;
}

.educational {
    color: var(--white-common);
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.3s ease;
}

.educational:hover {
    color: var(--yellow-100);
}

.instruct {
    font-size: 15px;
    color: var(--white-common);
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.3s ease;
}

.instruct:hover {
    color: var(--yellow-100);
}

.desktop-account {
    display: block;
}

.user-name {
    color: var(--white-common);
    font-weight: 500;
    font-size: 15px;
    white-space: nowrap;
}

/* Make the account dropdown arrow white in header */
.desktop-account .user-name .el-icon-arrow-down:before {
    color: var(--white-common) !important;
}

/* Mode toggle styles */
.mode-toggle-container {
    position: relative;
}

.mode-toggle-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.mode-toggle-button i {
    font-size: 24px;
    color: var(--white-common);
}

.mode-toggle-button:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.3);
}

.mode-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 200px;
    overflow: hidden;
}

.mode-option {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    color: #333333;
    cursor: pointer;
    transition: all 0.2s;
    gap: 12px;
}

.mode-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    flex-shrink: 0;
}

.mode-icon i {
    font-size: 20px;
}

.database-icon {
    background-color: #ff6b6b;
}

.database-icon i {
    color: white;
}

.profile-icon {
    background-color: #51cf66;
}

.profile-icon i {
    color: white;
}

.mode-option span {
    font-size: 15px;
    font-weight: 500;
}

.mode-option:hover {
    background-color: #f8f9fa;
}

.mode-option.active {
    background-color: #e7f5ff;
}

.mode-option.active span {
    color: var(--blue-200);
    font-weight: 600;
}

/* Notification control */
.notification-control {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.notification-badge {
    line-height: 1;
}

.notification-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.notification-icon i {
    font-size: 20px;
    color: var(--white-common);
}

.notification-icon:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.3);
}

/* Avatar control */
.avatar-control {
    display: flex;
    align-items: center;
}

.user-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    transition: all 0.3s ease;
    cursor: pointer;
}

.user-avatar i {
    font-size: 22px;
    color: var(--white-common);
}

.user-avatar:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
}

/* Remove old mode selector styles */
.mode-switcher {
    display: none;
}

/* Remove scroll from semester select dropdown */
::v-deep .semester-select-dropdown .el-select-dropdown__wrap {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    max-height: none !important;
}

::v-deep .semester-select-dropdown .el-select-dropdown__list {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
}

/* Remove vertical scroll from grade level select dropdown */
::v-deep .select-grade-level .el-select-dropdown__wrap {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    max-height: none !important;
}

::v-deep .select-grade-level .el-select-dropdown__list {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
}
</style>
